import { useState } from 'react';

import { Api } from '@.api';
import { useForm } from '@.hooks';
import { ApproveProductProposalFormScheme } from '@/Components/Partials/ProductProposals/ApproveProductProposalModal/ApproveProductProposalFormScheme';
import { ProductProposal } from '@/Services/api/methods/ProductsProposals';
import { ProductProposalService } from '@/Services/ProductProposal';
import { ProductProposalsBrandStateEnum } from '@/Types/ProductProposals';

import { validateOptions } from './validateOptions';

interface UseApproveProductParameters {
    productProposal: ProductProposal;
    updateProductProposal: () => void;
    close: () => void;
}

export const useApproveProduct = ({ productProposal, updateProductProposal, close }: UseApproveProductParameters) => {
    const [field, form] = useForm<ApproveProductProposalFormScheme>({});

    const [isShowUpdatedProductProposalMessage, setShowUpdatedProductProposalMessage] = useState<boolean>(false);

    const approve = () => {
        form.ifValid(async (data) => {
            const productProposalService = new ProductProposalService(Api.productsProposals());

            try {
                await productProposalService.approve(productProposal, data.udi, data.brand_id);

                updateProductProposal();
                close();
            } catch (error) {
                setShowUpdatedProductProposalMessage(true);
            }
        }, validateOptions(productProposal.brand_state !== ProductProposalsBrandStateEnum.FILLED));
    };

    return {
        approve,
        isShowUpdatedProductProposalMessage,
        field,
    };
};
